import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Box, Dropdown } from '@honda-canada/design-system-react';
import { useTranslation } from 'react-i18next';
import SectionTitleWithTooltip from '../shared/SectionTitleWithTooltip';
import themeStyles from './TermAndRateDropdown.styles';
import { selectTermAndRate } from '../../../core/reducers/financialCalculators';
import { useAppSelector } from '../../../core/utils';
import { useFetchCurrentVehicleFinancialCalculatorPayment } from '../../../core/apiHooks/useFetchPayment';
const Wrapper = themeStyles.apply(Box, 'Wrapper');
const TermAndRateDropdown = ({ calculatorId, disableAllFields, onChange }) => {
    const { t } = useTranslation();
    const termAndRate = useAppSelector(state => selectTermAndRate(state, calculatorId));
    const { data } = useFetchCurrentVehicleFinancialCalculatorPayment(calculatorId);
    const options = data === null || data === void 0 ? void 0 : data.terms.map(item => ({
        value: item.term,
        text: t('Pages.Bap.termAndRateDynamicLabel', { term: item.term, apr: item.apr }),
    }));
    const onChangeHandler = (value) => {
        if (onChange) {
            onChange(value);
        }
    };
    if (!options || !options.length) {
        return null;
    }
    return (_jsxs(Wrapper, { "data-testid": "cy-bap-term-and-rate", children: [_jsx(SectionTitleWithTooltip, { title: t('Pages.Bap.termAndRateOptionsLabel'), tooltip: t('Pages.Bap.termAndRateTooltipText'), dataTestId: "cy-bap-term-and-rate" }), _jsx(Dropdown, { ariaLabel: t('Pages.Bap.termAndRateOptionsLabel'), onChange: onChangeHandler, variant: "alternateBordered", options: options, value: termAndRate, styling: "secondary", disabled: disableAllFields, scrollable: true, height: "auto" })] }));
};
export default TermAndRateDropdown;
